import Header from "../../components/dashboard/header";
import {
  Breadcrumb,
} from "antd";
import { Link } from "react-router-dom";
import {
  DashboardOutlined,
} from "@ant-design/icons";
import { TiDocumentAdd } from "react-icons/ti";
import { useState, useEffect, useContext } from "react";
import { FaMoneyBill } from "react-icons/fa";
import {
  scrollToTop,
} from "../../helpers/dom";
import { usePVTypes } from "../../hooks/voucherTypes/voucherTypeQuery";
import { useFetchAllYears } from "../../hooks/financialYear/financialYearQuery";
import { useGetMemos } from "../../hooks/memo/memoQuery";
import { useGetAllTaxes } from "../../hooks/tax/taxQuery";
import {
  useGetVouchers,
} from "../../hooks/voucher/voucherQuery";
import RefreshContext from "../../context/refreshContext";
import {
  useGetAllBudgetItemsUnpaginated,
} from "../../hooks/budgetItem/budgetItemQuery";
import VoucherList from "../../components/voucher/VoucherList";
import VoucherForm from "../../components/voucher/VoucherForm";
import { eventBus } from "../../components/voucher/constants";
import VoucherStatistics from "../../components/voucher/VoucherStatistics";
import { useGetVoucherStatistics } from "../../hooks/voucher/voucherStatisticsQuery";

export default function Voucher() {
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [budgetItems, setBudgetItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [fYear, setFYear] = useState(0);
  const [voucher, setVoucher] = useState(null);

  const handleOpenModal = () => {
    setVoucher(null);
    setIsCreateOpen(true);
  };

  const handleEditModal = () => {
    setIsCreateOpen(true);
  };

  const { flag, setFlag } = useContext(RefreshContext);

  const { structures } = usePVTypes();
  const getMemos = useGetMemos();
  const [memos, setMemos] = useState([]);
  const getBudgetItems = useGetAllBudgetItemsUnpaginated();
  const { years } = useFetchAllYears();
  const { taxes: allTaxes } = useGetAllTaxes();
  const { loading: vouchersLoading, vouchers, totalElements } = useGetVouchers(currentPage - 1, pageSize, fYear);
  const { loading: statisticsLoading, statistics, error: statisticsError } = useGetVoucherStatistics(fYear);

  const handleYearSearch = async (value) => {
    setFYear(value);
    setCurrentPage(1);

    const m = await getMemos(value, null, true);
    setMemos(m ?? []);
  };

  const closeModal = () => {
    setVoucher(null);
    setIsCreateOpen(false);
  };

  const loadBudgetItems = async () => {
    const data = await getBudgetItems();
    setBudgetItems(data);
  };

  useEffect(() => {
    eventBus.addEventListener("voucher:edit", (e) => {
      console.log(e.detail.voucher);
      setVoucher(e.detail.voucher);
      handleEditModal();
    });

    eventBus.addEventListener("voucher:update", (e) => { });

    loadBudgetItems();
    scrollToTop();
  }, []);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  return (
    <>
      <div className="main-container">
        <Header />
        <div className="main-body">
          <div className="info-bar">
            <Breadcrumb>
              <Breadcrumb.Item>
                <DashboardOutlined className="dashboard-icon" />
                <Link to={"/dashboard"}>Dashboard</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <FaMoneyBill />
                <Link to={"/dashboard"}>Voucher</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <TiDocumentAdd />
                <Link to="/dashboard/manage">manage</Link>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <VoucherStatistics
            loading={statisticsLoading}
            statistics={statistics}
            error={statisticsError}
          />

          <VoucherList
            vouchers={vouchers}
            vouchersLoading={vouchersLoading}
            totalElements={totalElements}
            currentPage={currentPage}
            pageSize={pageSize}
            onPageChange={handlePageChange}
            years={years}
            onYearSearch={handleYearSearch}
            onOpenModal={handleOpenModal}
          />
        </div>
      </div>
      <VoucherForm
        isOpen={isCreateOpen}
        onClose={closeModal}
        voucher={voucher}
        years={years}
        memos={memos}
        allTaxes={allTaxes}
        budgetItems={budgetItems}
      />
    </>
  );
}